const state = {
    operatorId: null,
    organizationId: null,
    measurementType: null,
    audioStorageFlag: null,
    isUseAnalaysis: null,
    inspectionId: null,
    subjectId: null,
    gender: null,
    age: null,
    measurements: ['pa', 'ta', 'ka'].map(type => ({
        audioId: null,
        type: type,
        status: '未実施',
        date: '- - - - 年 - -月 - -日',
        time: '- - : - -',
        measurementStartTime: null,
        measurementType:null,
        isCompleted: false,
        dateVal: null,
    })),
    measurementsData: {},
    oralFrailtys: [{
        audioId: null,
        type: 'of',
        status: '未実施',
        result: false,
        score: null,
        date: '- - - - 年 - -月 - -日',
        time: '- - : - -',
        measurementStartTime: null,
        isCompleted: false,
        dateVal: null,
    }],
    oralFrailtysData: {},
    graphData: ['pa', 'ta', 'ka'].map(type => ({
        audioId: null,
        type: type,
        originalData: null,
        durationMean: null,
        vocabCount: null,
        vocabPerSecond: null,
        vocabCountSecond: null,
        vocabAnalysisCount: null,
        vocabAnalysisCountSecond: null,
        duringAnalysisType: null
    })),
    startDateTime: null,
    endDateTime: null,
    inspectionPDFURL: null,
    isLogin: false,
    userId: '',
    apiToken: null,
    analysisTypeFlag: null,
    resultReportName: '',
    resultReportData: {},
    resultOf5Data: {},
};

const mutations = {
    SET_OPERATOR_INFO(state, operatorInfo) {
        state.operatorId = operatorInfo.operator_id;
        state.organizationId = operatorInfo.organization_id;
        state.measurementType = operatorInfo.measurement_type;
        state.audioStorageFlag = operatorInfo.audio_storage_flag;
        state.isUseAnalaysis = operatorInfo.is_use_analysis == '1';
        state.apiToken = operatorInfo.api_token;
        state.analysisTypeFlag = operatorInfo.analysis_type_flag;
    },
    SET_SUBJECT_INFO(state, subjectInfo) {
        state.subjectId = subjectInfo.subject_id;
        state.gender = subjectInfo.gender;
        state.age = subjectInfo.age;
    },
    SET_INSPECTION_INFO(state, inspectionId) {
        state.inspectionId = inspectionId;
    },
    SET_MEASUREMENTS(state, measurementInfo) {
        const index = state.measurements.findIndex(item => item.type === measurementInfo.type);
        if (index !== -1) {
            state.measurements[index] = {
                audioId: measurementInfo.audioId,
                type: measurementInfo.type,
                status: measurementInfo.status,
                date: measurementInfo.date,
                time: measurementInfo.time,
                measurementStartTime: measurementInfo.measurementStartTime,
                measurementType: measurementInfo.measurementType,
                isCompleted: measurementInfo.isCompleted,
                dateVal: measurementInfo.dateVal,
            };
        }
    },
    SET_MEASUREMENTS_DATA(state, measurementsData) {
        state.measurementsData = measurementsData;
    },
    SET_ORALFRAILTY(state, oralFrailtyInfo){
        if (oralFrailtyInfo.type === 'of') {
            const index = state.oralFrailtys.findIndex(item => item.type === 'of');
            if (index !== -1) {
                state.oralFrailtys[index] = {
                    audioId: oralFrailtyInfo.audioId,
                    type: 'of',
                    status: oralFrailtyInfo.status,
                    result: oralFrailtyInfo.result,
                    score: oralFrailtyInfo.score,
                    date: oralFrailtyInfo.date,
                    time: oralFrailtyInfo.time,
                    measurementStartTime: oralFrailtyInfo.measurementStartTime,
                    isCompleted: oralFrailtyInfo.isCompleted,
                    dateVal: oralFrailtyInfo.dateVal,
                }
            }
        }
    },
    SET_ORALFRAILTY_DATA(state, oralFrailtysData) {
        state.oralFrailtysData = oralFrailtysData;
    },
    SET_GRAPH_DATA(state, graphData) {
        const index = state.graphData.findIndex(item => item.type === graphData.type);
        if (index !== -1) {
            state.graphData[index] = {
                audioId: graphData.audioId,
                type: graphData.type,
                originalData: graphData.originalData,
                durationMean: graphData.durationMean,
                vocabCount: graphData.vocabCount,
                vocabPerSecond: graphData.vocabPerSecond,
                vocabCountSecond: graphData.vocabCountSecond,
                vocabAnalysisCount: graphData.vocabAnalysisCount,
                vocabAnalysisCountSecond: graphData.vocabAnalysisCountSecond,
                duringAnalysisType: graphData.duringAnalysisType,
            };
        }
    },
    SET_START_DATE_TIME(state, startDateTime) {
        state.startDateTime = startDateTime;
    },
    SET_END_DATE_TIME(state, endDateTime) {
        state.endDateTime = endDateTime;
    },
    SET_INSPECTION_PDF_URL(state, inspectionPDFURL) {
        state.inspectionPDFURL = inspectionPDFURL;
    },
    CLEAR_OPERATOR(state) {
        state.operatorId = null;
        state.measurementType = null;
        state.audioStorageFlag = null;
        state.isUseAnalaysis = null;
        state.analysisTypeFlag = null;
    },
    CLEAR_SUBJECT(state) {
        state.inspectionId = null;
        state.subjectId = null;
        state.gender = null;
        state.age = null;
        state.measurements = ['pa', 'ta', 'ka'].map(type => ({
            audioId: null,
            type: type,
            status: this.$i18n.t('test_list.status_not_tested'),
            date: this.$i18n.t('test_list.date_placeholder'),
            time: '- - : - -',
            measurementStartTime: null,
            measurementType: null,
            isCompleted: false,
            dateVal: null,
        }));
        state.measurementsData = {};
        state.oralFrailtys = [{
            audioId: null,
            type: 'of',
            status: this.$i18n.t('test_list.status_not_tested'),
            result: false,
            score: null,
            date: this.$i18n.t('test_list.date_placeholder'),
            time: '- - : - -',
            measurementStartTime: null,
            isCompleted: false,
            dateVal: null,
        }],
        state.oralFrailtysData = {};
        state.graphData = ['pa', 'ta', 'ka'].map(type => ({
            audioId: null,
            type: type,
            originalData: null,
            durationMean: null,
            vocabCount: null,
            vocabPerSecond: null,
            vocabCountSecond: null,
            vocabAnalysisCount: null,
            vocabAnalysisCountSecond: null,
            duringAnalysisType:null
        }));
        state.startDateTime = null;
        state.endDateTime = null;
        state.inspectionPDFURL = null;
        state.resultReportName = ''
        state.resultReportData = {};
        state.resultOf5Data = {};
    },
    auth(state, user) {
        state.isLogin = true;
        state.userId = user;
    },
    CLEAR_AUTH(state) {
        state.isLogin = false;
        state.userId = '';
    },
    SET_RESULT_NAME(state, data) {
        state.resultReportName = data;
    },
    SET_RESULT_REPORT_DATA(state, data) {
        state.resultReportData = data;
    },
    SET_RESULT_OF5_DATA(state, data) {
        state.resultOf5Data = data;
    },
    CLEAR_REPORT(state) {
        state.resultReportName = ''
        state.resultReportData = {};
        state.resultOf5Data = {};
    },
};

const getters = {
    getOperatorId: state => state.operatorId,
    getOrganizationId: state => state.organizationId,
    getMeasurementType: state => state.measurementType,
    getAudioStorageFlag: state => state.audioStorageFlag,
    getisUseAnalaysis: state => state.isUseAnalaysis,
    getInspectionId: state => state.inspectionId,
    getSubjectId: state => state.subjectId,
    getGender: state => state.gender,
    getAge: state => state.age,
    // getMeasurements: state => state.measurements,
    getMeasurements: state => {
        return state.measurements.map(measurement => {
            const graphData = state.graphData.find(data => data.type === measurement.type);
            return {
                ...measurement,
                vocabCount: graphData ? graphData.vocabCount : null,
                vocabPerSecond: graphData && graphData.vocabPerSecond !== null
                ? Math.round(graphData.vocabPerSecond * 10) / 10 // 四捨五入して下1桁まで
                : null
            };
        });
    },
    getMeasurementsData: state => state.measurementsData,
    getOralFrailtys: state => state.oralFrailtys,
    getOralFrailtysData: state => state.oralFrailtysData,
    getGraphData: state => state.graphData,
    getStartDateTime: state => state.startDateTime,
    getEndDateTime: state => state.endDateTime,
    getInspectionPDFURL: state => state.inspectionPDFURL,
    getApiToken: state => state.apiToken,
    getAnalysisTypeFlag: state => state.analysisTypeFlag,
    getResultName: state => state.resultReportName,
    getResultReportData: state => state.resultReportData,
    getResultOf5Data: state => state.resultOf5Data,
};

const actions = {
    setOperatorInfo({ commit }, operatorInfo) {
        commit('SET_OPERATOR_INFO', operatorInfo);
    },
    setInspectionId({ commit }, inspectionId) {
        commit('SET_INSPECTION_INFO', inspectionId);
    },
    setSubjectInfo({ commit }, subjectInfo) {
        commit('SET_SUBJECT_INFO', subjectInfo);
    },
    setMeasurements({ commit }, measurements) {
        commit('SET_MEASUREMENTS', measurements);
    },
    setMeasurementsData({ commit }, measurementsData) {
        commit('SET_MEASUREMENTS_DATA', measurementsData);
    },
    setOralFrailty({ commit }, oralFrailtys){
        commit('SET_ORALFRAILTY', oralFrailtys);
    },
    setOralFrailty5Data({ commit }, oralFrailtysData) {
        commit('SET_ORALFRAILTY_DATA', oralFrailtysData);
    },
    setGraphData({ commit }, graphData) {
        commit('SET_GRAPH_DATA', graphData);
    },
    setStartDateTime({ commit }, startDateTime) {
        commit('SET_START_DATE_TIME', startDateTime);
    },
    setEndDateTime({ commit }, endDateTime) {
        commit('SET_END_DATE_TIME', endDateTime);
    },
    setInspectionPDFURL({ commit }, inspectionPDFURL) {
        commit('SET_INSPECTION_PDF_URL', inspectionPDFURL);
    },
    clearOperator({ commit }) {
        commit('CLEAR_OPERATOR');
    },
    clearSubject({ commit }) {
        commit('CLEAR_SUBJECT');
    },
    fetch(context, user) {
        context.commit('auth', user);
    },
    clearAuth({ commit }) {
        commit('CLEAR_AUTH');
    },
    setResultName({ commit }, data) {
        commit('SET_RESULT_NAME', data);
    },
    setResultReportData({ commit }, data) {
        commit('SET_RESULT_REPORT_DATA', data);
    },
    setResultOf5Data({ commit }, data) {
        commit('SET_RESULT_OF5_DATA', data);
    },
    clearReport({ commit }) {
        commit('CLEAR_REPORT');
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
